(function () {
  "use strict";
  var doc = document;
  var SEL = "[data-xg-count]";
  var reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function duration() {
    var raw = getComputedStyle(doc.documentElement)
      .getPropertyValue("--xg-dur-scene")
      .trim();
    var n = parseFloat(raw);
    if (!isFinite(n) || n <= 0) return 640;
    return raw.indexOf("ms") > -1 ? n : n * 1000;
  }
  function parse(el) {
    var node = el.querySelector(".xg-stat__num") || el;
    var text = node.textContent || "";
    var match = text.match(/-?[\d,]*\.?\d+/);
    if (!match) return null;
    var digits = match[0];
    var value = parseFloat(digits.replace(/,/g, ""));
    if (!isFinite(value)) return null;
    var dot = digits.indexOf(".");
    return {
      node: node,
      value: value,
      decimals: dot === -1 ? 0 : digits.length - dot - 1,
      grouped: digits.indexOf(",") > -1,
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + digits.length)
    };
  }
  function format(spec, n) {
    var body = n.toFixed(spec.decimals);
    if (spec.grouped) {
      var parts = body.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      body = parts.join(".");
    }
    return spec.prefix + body + spec.suffix;
  }
  function run(el) {
    if (el.hasAttribute("data-xg-counted")) return;
    el.setAttribute("data-xg-counted", "");
    var spec = parse(el);
    if (!spec || reduced) return;
    var total = duration();
    var start = 0;
    function frame(now) {
      if (!start) start = now;
      var p = Math.min((now - start) / total, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      spec.node.textContent = format(spec, spec.value * eased);
      if (p < 1) window.requestAnimationFrame(frame);
      else spec.node.textContent = format(spec, spec.value);
    }
    spec.node.textContent = format(spec, 0);
    window.requestAnimationFrame(frame);
  }
  function host(el) {
    return el.closest(".xg-reveal") || el;
  }
  var watcher = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var target = records[i].target;
      if (target.getAttribute("data-xg-reveal") !== "in") continue;
      var nodes = target.matches(SEL) ? [target] : target.querySelectorAll(SEL);
      for (var j = 0; j < nodes.length; j += 1) run(nodes[j]);
    }
  });
  function init(scope) {
    var nodes = (scope || doc).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];
      var anchor = host(el);
      if (anchor === el || anchor.getAttribute("data-xg-reveal") === "in") {
        run(el);
      } else {
        watcher.observe(anchor, { attributes: true, attributeFilter: ["data-xg-reveal"] });
      }
    }
  }
  init(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  doc.addEventListener("shopify:section:unload", function () {
    watcher.disconnect();
    init(doc);
  });
  window.XG = window.XG || {};
  window.XG.stat = { init: init };
})();
